const CREATE_NETWORK = "network::create";
const CREATE_NETWORK_SUCCESS = "network::create::success";
const DELETE_NETWORK = "network::delete";
const DELETE_NETWORK_SUCCESS = "network::delete::success";
const LOAD_NETWORK = "network::load";
const LOAD_NETWORK_FAILURE = "network::load::failure";
const LOAD_NETWORK_SUCCESS = "network::load::success";
const LOAD_NETWORKS = "network::load-all::success";
const LOAD_NETWORKS_FAILURE = "network::load-all::failure";
const EDIT_NETWORK = "network::edit";
const EDIT_NETWORK_SUCCESS = "network::edit::success";
const EDIT_NETWORK_FLAGS = "network::edit-flags";
const EDIT_NETWORK_FLAGS_SUCCESS = "network::edit-flags::success";
const EDIT_NETWORK_PARAMS = "network::edit-params";
const EDIT_NETWORK_PARAMS_SUCCESS = "network::edit-params::success";

export {
  CREATE_NETWORK,
  CREATE_NETWORK_SUCCESS,
  DELETE_NETWORK,
  DELETE_NETWORK_SUCCESS,
  EDIT_NETWORK,
  EDIT_NETWORK_FLAGS,
  EDIT_NETWORK_FLAGS_SUCCESS,
  EDIT_NETWORK_PARAMS,
  EDIT_NETWORK_PARAMS_SUCCESS,
  EDIT_NETWORK_SUCCESS,
  LOAD_NETWORK,
  LOAD_NETWORK_FAILURE,
  LOAD_NETWORK_SUCCESS,
  LOAD_NETWORKS,
  LOAD_NETWORKS_FAILURE,
};
